import t from "./index82.mjs";
import f from "./index104.mjs";
function i(o) {
  var r = f(o, "string");
  return t(r) == "symbol" ? r : r + "";
}
export {
  i as default
};
